import api from '../api';
import qs from 'qs';

export const getAuthLinkApi = (query) =>
  api
    .get(`/MicrosoftAuthLink?${qs.stringify(query, { allowDots: true, indices: false })}`)
    .then((res) => res.data);
